import React from "react";
import {
  AppBar,
  Toolbar,
  Container,
  useMediaQuery,
  withWidth,
  useScrollTrigger,
  Slide,
} from "@material-ui/core";

import {
  createStyles,
  makeStyles,
  Theme,
  useTheme,
} from "@material-ui/core/styles";
import GeneralMenu from "../../components/HeaderComponents/GeneralMenu";
import MobileMenu from "../../components/HeaderComponents/MobileMenu";
import { useSpring, animated } from "react-spring";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    clsToolBar: {
      flexGrow: 1,

      // background: "transparent",
      [theme.breakpoints.down("md")]: {
        padding: 0,
        width: "100%",
      },
    },
    paddingSide: {
      paddingLeft: "6rem",
      paddingRight: "6rem",
      [theme.breakpoints.down("md")]: {
        padding: 0,
      },
    },
  })
);

function HeaderSection(props: any) {
  const classes = useStyles();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  const [{ backgroundColor }, set] = useSpring(() => ({
    backgroundColor: "#ffffff00",
  }));

  // const [topState, setTopState] = useState<number>(0);

  // const [judege, setJudege] = useState<boolean>(false);

  // const mouseEnter = () => {
  //   setJudege(true);

  //   set({
  //     backgroundColor: "white",
  //   });
  // };

  // const mouseLeave = () => {
  //   setJudege(false);

  //   if (topState && judege == true) {

  //     return;
  //   } else {
  //     set({
  //       backgroundColor: "#ffffff00",
  //     });
  //   }
  // };

  // const onScrolling = () => {

  //   let top = Number(window.pageYOffset);
  //   setTopState(top);
  // };

  // useEffect(() => {
  //   window.addEventListener("mouseenter", () => {});
  //   return () => {
  //     window.removeEventListener("mouseenter", () => {});
  //   };
  // }, [window]);

  // useEffect(() => {
  //   window.addEventListener("scroll", onScrolling);
  //   return () => {
  //     window.removeEventListener("scroll", onScrolling);
  //   };
  // }, [window]);

  // useEffect(() => {
  //   if (topState) {

  //     set({
  //       backgroundColor: "white",
  //     });
  //   } else if (topState == 0 && judege == true) {
  //     set({
  //       backgroundColor: "white",
  //     });
  //   } else {

  //     set({
  //       backgroundColor: "#ffffff00",
  //     });
  //   }
  //   return () => {};
  // }, [topState, judege]);

  return (
    <React.Fragment>
      <AppBar
        className={classes.clsToolBar}
        elevation={1}
        // onMouseEnter={mouseEnter}
        // onMouseLeave={mouseLeave}
        component={animated.div}
        // position={"sticky"}
        style={{
          willChange: "contents",
          backgroundColor: "white",
          // backgroundColor: backgroundColor.interpolate(
          //   (backgroundColor) => `${backgroundColor}`
          // ),
        }}
      >
        <Container
          maxWidth={"xl"}
          style={
            {
              // backgroundColor: "rgba(0,0,0,0,1)",
            }
          }
          className={classes.paddingSide}
          disableGutters={true}
        >
          {/* <GeneralMenu topState={topState} judege={judege} /> */}

          {/* {!matches ? <GeneralMenu /> : <MobileMenu />} */}
          {!matches ? <GeneralMenu /> : <MobileMenu />}
        </Container>
      </AppBar>
    </React.Fragment>
  );
}

export default withWidth()(HeaderSection);
